import React from 'react';

const BillingHeader = () => {
  return <div className='typo-title1 text-text-primary'>Billing history</div>;
};

export default BillingHeader;
